// eslint-disable-next-line @cbhq/ts-no-enum
enum ApiErrorType {
  // General API Error Codes
  Unauthorized = 'UNAUTHORIZED',
}

export const ErrorType = {
  ...ApiErrorType,
};
